import PageHeader from "@/components/PageHeader";
import ListSection from "@/components/ListSection";

const FIELDS = [
  { name: "type", label: "Utbildningstyp", type: "select", options: ["Grundskola", "Gymnasium", "Yrkeshögskola", "Högskola/Universitet", "Folkhögskola", "Kurs", "Certifiering", "Annat"] },
  { name: "name", label: "Utbildningsnamn", type: "text", placeholder: "T.ex. Logistikprogrammet" },
  { name: "school", label: "Skola", type: "text", placeholder: "Skolans/lärosätets namn" },
  { name: "focus", label: "Inriktning", type: "text", placeholder: "Inriktning/program" },
  { name: "start_year", label: "Startår", type: "text", placeholder: "ÅÅÅÅ" },
  { name: "end_year", label: "Slutår", type: "text", placeholder: "ÅÅÅÅ" },
  { name: "status", label: "Status", type: "select", options: ["Avslutad", "Pågående", "Delvis avslutad"] },
  { name: "relevant_modules", label: "Relevanta moment", type: "textarea", full: true },
  { name: "certifications", label: "Certifieringar", type: "tags", full: true, placeholder: "Skriv och tryck Enter" },
  { name: "courses", label: "Kurser", type: "tags", full: true, placeholder: "Skriv och tryck Enter" },
];

export default function Utbildning() {
  return (
    <div>
      <PageHeader title="Utbildning" description="Lägg till obegränsat antal utbildningar, kurser och certifieringar." />
      <ListSection
        endpoint="educations"
        fields={FIELDS}
        addLabel="Lägg till utbildning"
        emptyText="Ingen utbildning tillagd ännu."
        ai={{
          section: "educations",
          title: "AI-hjälp med din utbildning",
          intro: "Jag hjälper dig fylla i utbildningar, kurser och certifieringar – du godkänner varje tillägg.",
          suggestions: [
            "Hjälp mig lägga in min gymnasieutbildning",
            "Hur beskriver jag en kurs jag gått?",
            "Vad räknas som utbildning jag kan ta med?",
          ],
          mapProposal: (p) => ({
            type: p.value?.type || "Annat",
            name: p.value?.name || "",
            school: p.value?.school || "",
            focus: p.value?.focus || "",
            start_year: p.value?.start_year || "",
            end_year: p.value?.end_year || "",
            status: p.value?.status || "Avslutad",
          }),
        }}
        summary={(it) => ({
          title: it.name,
          subtitle: it.school,
          meta: `${it.type || ""} · ${it.start_year || "?"}–${it.end_year || "?"} · ${it.status || ""}`,
        })}
      />
    </div>
  );
}
